export function convertStatus(status: string) {
  switch (status) {
    case 'Draft':
      return 'draft'
    case 'In progress':
      return 'in_progress'
    case 'Completed':
      return 'completed'
    default:
      return ''
  }
}

export function getStatusStyle(status?: string) {
  if (status === 'In progress') {
    return {
      statusIcon: 'SvgoStatusInProgress',
      statusColor: 'text-accent-purple-400',
    }
  }
  if (status === 'Completed') {
    return {
      statusIcon: 'SvgoStatusCompleted',
      statusColor: 'text-risk-green-base',
    }
  }
  if (status === 'Draft') {
    return {
      statusIcon: 'SvgoStatusDraft',
      statusColor: 'text-risk-orange-dark',
    }
  }
  return null
}
